import React, { Children } from 'react';

import './HeaderNavigation.scss';

export type HeaderNavigationProps = {
	isOpened: boolean;
	isExpanded: boolean;
	children?: React.ReactNode;
};

const HeaderNavigation: React.FC<HeaderNavigationProps> = ({
	isOpened,
	isExpanded,
	children,
}) => {
	const [primaryNavigation, secondaryNavigation, ...rest] =
		Children.toArray(children);

	const isExpandedClass = isExpanded ? 'is-expanded' : '';

	return (
		<nav className="blk-ac-header-navigation" aria-label="Primary Navigation">
			<div
				className={`navigation-wrapper front-of-bg ${isOpened ? 'opened' : ''}`}
				data-testid="navigation-wrapper"
				id="navigation-wrapper"
			>
				{primaryNavigation}
				<div className={['drawer-wrapper', isExpandedClass].join(' ')}>
					{secondaryNavigation}
					{rest}
				</div>
			</div>
		</nav>
	);
};

export default HeaderNavigation;
